// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { lyra as _lyra } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the lyra chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 957
 * Chain Name: Lyra Chain
 * Default Block Explorer: https://explorer.lyra.finance
 * Default RPC URL: https://rpc.lyra.finance
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { lyra } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: lyra,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const lyra = createCommon({
	..._lyra,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
